import {Directive, ViewContainerRef} from '@angular/core';

@Directive({selector: '[pubFilter]', standalone: true})
export class FilterSelectorDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
